import { render, staticRenderFns } from "./open.vue?vue&type=template&id=a13c7d62&"
import script from "./open.vue?vue&type=script&lang=js&"
export * from "./open.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports